export const styles = {
  col: {
    padding: 3,
    minHeight: 20,
    flex: 1,
    flexDirection: "row",
    borderRight: "1px solid #000",
  },
};
